export const FORM_FIELDS_ERR_CONSTANTS: any = {
  firstName: {
    key: 'firstName',
    requiredError: 'First name is required.',
  },
  lastName: {
    key: 'lastName',
    requiredError: 'Last name is required.',
  },
  phone: {
    key: 'phone',
    requiredError: 'Phone number is required.',
    onlyNumericErr: 'Only numerical input is allowed.',
    numberInvalidErr: 'Please input a valid phone number.',
  },
  pan: {
    key: 'pan',
    requiredError: 'PAN number is required.',
    regexErr: 'Please enter a valid PAN number.',
  },
  maskedPhone: {
    key: 'maskedPhone',
    requiredError: 'Phone number is required.',
    regexErr: 'Only numerical input is allowed.',
  },
  email: {
    key: 'email',
    requiredError: 'Email is required.',
    regexErr: 'Please enter a valid email',
  },
  termsConsent: {
    key: 'termsConsent',
    requiredError: 'Please accept the undertaking to proceed further',
  },
  isGst: {
    key: 'isGst',
  },
  gst: {
    key: 'gst',
  },
  lender_id: {
    key: 'lender_id',
  },
  dob: {
    key: 'dob',
    requiredError: 'Date of birth is required',
  },
  pincode: {
    key: 'pincode',
    requiredError: 'Pincode is required',
  },
  annualIncome: {
    key: 'annualIncome',
    requiredError: 'Annual Income is required',
  },
  businessAge: {
    key: 'businessAge',
    requiredError: 'Business age is required',
  },
  annualTurnover: {
    key: 'annualTurnover',
    requiredError: 'Annual Turnover is required',
  },
  businessConstitution: {
    key: 'businessConstitution',
    requiredError: 'Business type is required',
  },
  employmentType: {
    key: 'employmentType',
    requiredError: 'Employment Type is required',
  },
  loanAmount: {
    key: 'loanAmount',
    requiredError: 'Loan amount is required',
  },
  houseOwnership: {
    key: 'houseOwnership',
    requiredError: 'Home Ownership is required',
  },
};

export const AUTH_STEPS = {
  userDetails: 'userDetails',
  businessLoanUserDetails: 'businessUserDetails',
  personalLoanUserDetails: 'perosnalUserDetails',
  otpDetails: 'otpDetails',
  panDetails: 'panDetails',
  maskedNumberDetails: 'maskedNumberDetails',
  reportDetails: 'reportDetails',
  personalLastStepDetails: 'personalLastStep',
  formSteps: 'formSteps',
  businessLastStepDetails: 'businessLastStep',
  bankStatements: 'bankStatements',
  lendersStep: 'lendersStep',
  uploadDocuments: 'uploadDocuments',
  loanOffers: 'loanOffers',
};

export const FETCH_CREDIT_RESPONSES = {
  panDetailsRequired: 'pan details required',
  accountlimitExceeded: 'account limit exceeded',
  noReportFound: 'no user report found',
  userNotEligible: 'user not eligible to fetch score',
  technicalError: 'technical error occured',
};

type UserInputDetails = {
  phone: string;
  firstName: string;
  lastName: string;
  email?: string;
  businessConstitution?: string;
};

export const FIELD_KEYS: Record<
  keyof UserInputDetails,
  keyof UserInputDetails
> = {
  phone: 'phone',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  businessConstitution: 'businessConstitution',
};

export const STEPS_STATUS = {
  complete: 'complete',
  incomplete: 'incomplete',
  active: 'active',
  inactive: 'inactive',
};

export const LENDER_FEATURES = {
  roI: 'RoI',
  table_roi: 'roi',
  emi: 'Emi',
  processingFee: 'processingFee',
  supportedLoanAmount: 'supportedLoanAmount',
  name: 'Name',
  relevance: 'Relevance',
};

export const documentMapping: any = {
  'Udyam certificate': 2,
  'Import export certificate': 3,
  'Shop & establishment act license': 4,
  'FSSAI license': 5,
  'Factory license': 6,
};

export const DocumentType = {
  BANK_STATEMENT: 1,
  FACTORY_LICENSE: 6,
  GST_REGISTERATION_CERT: 7,
};

export const BSA_STATUS = {
  pending: 'pending',
  complete: 'complete',
  failed: 'failed',
  idle: 'idle',
  success: 'success',
} as const;
